function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: "512",
  viewBox: "0 0 510 510",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M405 0H60v465h30V30h315z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120 60v450h210V390h120V60zm165 330H180v-30h105zm105-60H180v-30h210zm0-60H180v-30h210zm0-60H180v-30h210zm0-60H180v-30h210z",
  fill: "#595b5c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M360 501.213L441.213 420H360z",
  fill: "#595b5c"
})));